import React from 'react';
import styles from './printSubmissionReport.module.scss';
import { formatDate } from '../../util/date';

type ButtonProps = React.ComponentPropsWithoutRef<'button'>;

const PrintSubmissionReport = React.forwardRef<HTMLDivElement, any>((props, ref) => {
  return (
    <div className={styles.printReport} ref={ref}>
      <h3 className={styles.headerText}>ECRI and the ISMP PSO Event Report</h3>
      <hr />
      <div className={styles.formGroup}>
        <label className={styles.formLabel}>Event Submitted On</label>
        <p>{formatDate(new Date())}</p>
      </div>
      <div className={styles.formGroup}>
        <label className={styles.formLabel}>First Name</label>
        <p>{props.data.firstName}</p>
      </div>
      <div className={styles.formGroup}>
        <label className={styles.formLabel}>Last Name</label>
        <p>{props.data.lastName}</p>
      </div>
      <div className={styles.formGroup}>
        <label className={styles.formLabel}>Email</label>
        <p>{props.data.email}</p>
      </div>
      <div className={styles.formGroup}>
        <label className={styles.formLabel}>Telephone Contact</label>
        <p>{props.data.telephoneContact}</p>
      </div>
      <div className={styles.formGroup}>
        <label className={styles.formLabel}>Event Type</label>
        <p>
          {props.data.eventTypeId === 1
            ? 'Medication related'
            : 'Vaccine related'}
        </p>
      </div>
      <div className={styles.formGroup}>
        <label className={styles.formLabel}>Event Description</label>
        <p>{props.data.eventHazardousCondition}</p>
      </div>
      <div className={styles.formGroup}>
        <label className={styles.formLabel}>
          Causes and Contributing Factors
        </label>
        <p>{props.data.causesContributingFactors}</p>
      </div>
      <div className={styles.formGroup}>
        <label className={styles.formLabel}>Risk Reduction Strategies</label>
        <p>{props.data.riskReductionStrategies}</p>
      </div>
      {props.data.documents.length > 0 && (
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Upload Images/Files</label>
          {props.data.documents.map((k: any) => (
            <p key={k.name}>{k.name}</p>
          ))}
        </div>
      )}
      <div className={styles.pageFooter}>
        <div className="row">
          <div className="col-md-10">
            <p className={styles.footerText}>
              PATIENT SAFETY WORK PRODUCT. PRIVILEGED AND CONFIDENTIAL. NOT
              SUBJECT TO DISCOVERY. CANNOT BE USED AS EVIDENCE.
            </p>
          </div>
          <div className="col-md-2">
            <img
              className={styles.ecriPsoLogo}
              src={`${process.env.GATSBY_ASSET_CDN_SITE}/styles/ecri-pso_logo_fc_trimmed.png`}
              alt="ECRI PSO Logo"
            />
          </div>
        </div>
      </div>
    </div>
  );
});

export default PrintSubmissionReport;